// extracted by mini-css-extract-plugin
module.exports = {"table-data-cell-border-bottom":"styles-module__table-data-cell-border-bottom___11wKp"};